export const listProfileBuildingTypeKeys = (profile) => Object.keys(profile.defaultFloorAreaSquareMetreByBuildingType);
